import cn from 'classnames';
import { TPlansDetails, TPlanFeatured } from 'src/types/plans.types';
import HighlightTab from './HighlightTab/HighlightTab';
import styles from './Table/pricing.module.scss';

type TabRowProps = {
  smartHome: TPlansDetails['smartHome'];
  secondary: TPlansDetails['secondary'];
};

const TabRow = ({ smartHome, secondary }: TabRowProps) => {
  const { featured: smartHomeFeatured } = smartHome as TPlanFeatured;
  const { featured: secondaryFeatured } = secondary as TPlanFeatured;
  return smartHomeFeatured || secondaryFeatured ? (
    <div className={cn(styles.row, styles.tabRowContainer)}>
      <div className={styles.selectPlanCol} />
      <div className={styles.smartHomeCol}>
        <HighlightTab isPlaceholder={!smartHomeFeatured} />
      </div>
      <div className={styles.secondaryCol}>
        <HighlightTab isPlaceholder={!secondaryFeatured} />
      </div>
    </div>
  ) : null;
};

export default TabRow;
